import { FormattedMessage as FM } from "react-intl";

function AppearanceSectionTitle({ id }) {
  return (
    <h3 className="col-span-full text-lg font-bold uppercase text-neutral-700">
      <FM id={id} />
    </h3>
  );
}

export default AppearanceSectionTitle;
